import { render } from "./OidoDivider.vue?vue&type=template&id=181bacd1&scoped=true"
import script from "./OidoDivider.vue?vue&type=script&lang=js"
export * from "./OidoDivider.vue?vue&type=script&lang=js"

import "./OidoDivider.vue?vue&type=style&index=0&id=181bacd1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-181bacd1"]])

export default __exports__